import { Info } from 'lucide-react';

import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';
import { useNow } from '@/hooks/useNow';

import {
  NewsItem,
  NewsItemBody,
  NewsItemDescription,
  NewsItemIcon,
  NewsItemThumbnail,
} from '../news-item';

import { getManualNews } from './get-manual-news';

export function ManualNews() {
  const now = useNow();
  const me = useMe();
  const featureFlag = useFeatureFlag();

  if (me.whiteLabel) {
    return null;
  }

  const newsSources = getManualNews(now, featureFlag, me);
  const sortedEntries = newsSources
    .flatMap((n) => n)
    .map((item) => ({
      ...item,
      priority: item.priority ?? 0,
    }))
    .sort((a, b) => b.priority - a.priority); // Higher priority items first

  if (sortedEntries.length === 0) {
    return (
      <NewsItem>
        <NewsItemIcon>
          <Info className="size-full text-gray-400" />
        </NewsItemIcon>
        <NewsItemBody>
          <NewsItemDescription isCollapsible={false}>
            You are all caught up! No other updates at the moment. Please check
            back soon.
          </NewsItemDescription>
        </NewsItemBody>
      </NewsItem>
    );
  }

  return (
    <>
      {sortedEntries.map((news) => (
        <NewsItem key={news.key}>
          <NewsItemIcon>{news.icon}</NewsItemIcon>
          <NewsItemBody>
            <NewsItemDescription>{news.label}</NewsItemDescription>
            <NewsItemThumbnail thumbnail={news.thumbnail} />
          </NewsItemBody>
        </NewsItem>
      )) ?? null}
    </>
  );
}
